import { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var ViewHtmlComponent = /** @class */ (function () {
    function ViewHtmlComponent(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    Object.defineProperty(ViewHtmlComponent.prototype, "html", {
        set: function (input) {
            this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(input || '');
        },
        enumerable: true,
        configurable: true
    });
    ViewHtmlComponent.prototype.ngOnInit = function () {
    };
    return ViewHtmlComponent;
}());
export { ViewHtmlComponent };
